import { browserTracingIntegration as browserTracingIntegration$1, WINDOW, startBrowserTracingPageLoadSpan } from '@sentry/browser';
import { browserPerformanceTimeOrigin, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, debug } from '@sentry/core';
import { DEBUG_BUILD } from '../debug-build.js';

/**
 * Returns the value of a meta-tag
 */
function getMetaContent(metaName) {
  const optionalDocument = WINDOW.document ;
  const metaTag = optionalDocument?.querySelector(`meta[name=${metaName}]`);
  return metaTag?.getAttribute('content') || undefined;
}

/**
 * A custom browser tracing integrations for Astro.
 */
function browserTracingIntegration(
  options = {},
) {
  const integration = browserTracingIntegration$1({ ...options, instrumentPageLoad: false });

  return {
    ...integration,
    afterAllSetup(client) {
      // Original integration afterAllSetup call
      integration.afterAllSetup?.(client);

      if (WINDOW.location) {
        if (options.instrumentPageLoad != false) {
          const origin = browserPerformanceTimeOrigin();

          const { name, source } = getPageloadSpanName();

          startBrowserTracingPageLoadSpan(client, {
            name,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: origin ? origin / 1000 : undefined,
            attributes: {
              [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: source,
              [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.pageload.astro',
            },
          });
        }
      }
    },
  };
}

function getPageloadSpanName() {
  try {
    const routeNameFromMetaTags = getMetaContent('sentry-route-name');
    if (routeNameFromMetaTags) {
      const decodedRouteName = decodeURIComponent(routeNameFromMetaTags);

      DEBUG_BUILD && debug.log(`[Tracing] Using route name from Sentry HTML meta-tag: ${decodedRouteName}`);

      return {
        name: decodedRouteName,
        source: 'route',
      };
    }
  } catch {
    // fail silently if decoding or reading the meta tag fails
  }
  return {
    name: WINDOW.location.pathname,
    source: 'url',
  };
}

export { browserTracingIntegration };
//# sourceMappingURL=browserTracingIntegration.js.map
